<template>
  <el-row>
    <h2>Filter/Search</h2>
    <el-row :gutter="24">
      <el-col :lg="6">
        Division:  <all-division-dropdown v-model="divisionId" :inputModel="divisionId"></all-division-dropdown>
      </el-col>
      <el-col :lg="6">
        Approval Role:  <role-dropdown v-model="approvalRoleId" :inputModel="approvalRoleId"></role-dropdown>
      </el-col>
      <el-col :lg="6">
        User:  <user-dropdown v-model="userId" :inputModel="userId"></user-dropdown>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" class="searchBtn" @click="search()">Search</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="warning" class="searchBtn" @click="clear()">Clear Options</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" class="searchBtn" @click="showAll()">Show All</el-button>
      </el-col>
    </el-row>

    <br /><br />
    <el-col :span="24">
      <h3>Approval Roles and Users</h3>
      <transition name="panel">
        <div class="pea-panel .rules-panel">
          <el-table :data="authorizationUserRoles" @current-change="selectRow" @sort-change="sortChange" class="allApproversTable" v-loading="tableLoading">
            <el-table-column prop="peaDivisionName" align="left"
                             label="Division" sortable="custom">
            </el-table-column>
            <el-table-column prop="roleName" align="left"
                             label="Approval Role" sortable="custom">
            </el-table-column>
            <el-table-column prop="userFullName" align="left"
                             label="User" sortable="custom">
            </el-table-column>
          </el-table>
          <el-pagination v-if="resultTotal > pageSize"
                         @current-change="fetchData"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="total, prev, pager, next"
                         :total="resultTotal">
          </el-pagination>
        </div>
      </transition>
    </el-col>
  </el-row>
</template>
<script>
import router from '@/router'
export default {
  name: 'adminPEAApprovalRolesAndUsers',
  data () {
    return {
      authorizationUserRoles: [],
      divisionId: '',
      userId: '',
      approvalRoleId: '',
      currentPage: 1,
      pageSize: 15,
      resultTotal: 0,
      column: 'Level',
      order: 'Ascending',
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.search()
    },
    selectRow: function (row) {
      if (this.$store.getters.isAdmin || this.$store.getters.isServiceDesk) {
        router.push('changeApprovalUserRole/' + row.id)
      }
    },
    search () {
      this.tableLoading = true
      var tempDiv = this.divisionId
      var tempUser = this.userId
      var tempApproval = this.approvalRoleId
      if (this.divisionId === '' || this.divisionId === null) {
        tempDiv = 0
      }
      if (this.userId === '' || this.userId === null) {
        tempUser = 0
      }
      if (this.approvalRoleId === '' || this.approvalRoleId === null) {
        tempApproval = 0
      }
      var call = '/getActivePEAUserAuthorizationRolesByFilters/' + '?page=' + this.currentPage + '&pageSize=' + this.pageSize + '&divisionId=' + tempDiv + '&approvalRoleId=' + tempApproval + '&userId=' + tempUser + '&sortColumn=' + this.column + '&sortOrder=' + this.order
      this.$axios.get(call).then(response => {
        this.authorizationUserRoles = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
      })
    },
    clear () {
      this.userId = ''
      this.divisionId = ''
      this.approvalRoleId = ''
      // this.fetchData()
    },
    showAll () {
      this.userId = ''
      this.divisionId = ''
      this.approvalRoleId = ''
      this.fetchData()
    },
    sortChange: function (col) {
      this.column = col.prop
      this.order = col.order
      this.search()
    },
    startUp () {
      this.fetchData()
    }
  },
  mounted () {
    this.startUp()
  }
}
</script>

<style scoped>
  h4 {
    margin-bottom: 20px;
  }

  .rules-panel {
    padding-bottom: 30px;
  }
</style>
<style>
  .allApproversTable tr:hover {
    cursor: pointer;
  }
</style>
